/**
* DO NOT EDIT
* Generated by fds-dictionary on Thu Apr 16 2020 22:10:08 GMT+0000 (Coordinated Universal Time)
* github.com/cbinsights/form-design-system/
*/

exports.BORDER_COLOR_INPUT = 'rgba(64, 64, 64, 0.24)';
exports.BORDER_COLOR_FOCUS_RING = 'rgba(76, 171, 206, 0.6)';
exports.BORDER_RADIUS_DEFAULT = '4px';
exports.COLOR_CHARCOAL = '#404040';
exports.COLOR_SLATE = '#757575';
exports.COLOR_GRAY = '#a2a0a0';
exports.COLOR_SILVER = '#c2bfbf';
exports.COLOR_TIMBERWOLF = '#d6d4d4';
exports.COLOR_LIGHT_GRAY = '#f2f2f2';
exports.COLOR_WHITE = '#ffffff';
exports.COLOR_NAVY = '#003366';
exports.COLOR_BLUE = '#006699';
exports.COLOR_AQUA = '#4cabce';
exports.COLOR_SKY = '#bbdbe5';
exports.COLOR_HAZE = '#f1f5f7';
exports.COLOR_RED = '#e5323e';
exports.COLOR_ORANGE = '#ff6633';
exports.COLOR_SIENNA = '#f9a862';
exports.COLOR_SAND = '#fcc89a';
exports.COLOR_GREEN = '#00986b';
exports.COLOR_MINT = '#70c390';
exports.COLOR_PURPLE = '#a02385';
exports.COLOR_VIOLET = '#d772ad';
exports.FONT_COLOR_LINK = '#006699';
exports.FONT_COLOR_LINK_INVERTED = '#4cabce';
exports.FONT_COLOR_HEADING = '#404040';
exports.FONT_COLOR_PRIMARY = 'rgba(64, 64, 64, 0.87)';
exports.FONT_COLOR_SECONDARY = 'rgba(64, 64, 64, 0.60)';
exports.FONT_COLOR_HINT = 'rgba(64, 64, 64, 0.38)';
exports.FONT_COLOR_HEADING_INVERTED = '#ffffff';
exports.FONT_COLOR_PRIMARY_INVERTED = 'rgba(255, 255, 255, 0.87)';
exports.FONT_COLOR_SECONDARY_INVERTED = 'rgba(255, 255, 255, 0.60)';
exports.FONT_COLOR_HINT_INVERTED = 'rgba(255, 255, 255, 0.38)';
exports.FONT_COLOR_ERROR = '#e5323e';
exports.FONT_COLOR_SUCCESS = '#00986b';
exports.FONT_COLOR_ERROR_INVERTED = '#e5323e';
exports.FONT_COLOR_SUCCESS_INVERTED = '#70c390';
exports.FONT_FAMILY_CONDENSED = '\'Roboto Condensed\', \'Helvetica Neue\', Helvetica, \'Segoe UI\', Arial, sans-serif';
exports.FONT_FAMILY_DEFAULT = 'Roboto, \'Helvetica Neue\', Helvetica, \'Segoe UI\', Arial, sans-serif';
exports.FONT_FAMILY_MONO = 'Monaco, Consolas, monospace';
exports.FONT_LINE_HEIGHT_BIG_TEXT = '1.2';
exports.FONT_LINE_HEIGHT_DEFAULT = '1.5';
exports.FONT_LINE_HEIGHT_SMALL_TEXT = '1.8';
exports.FONT_SIZE_XS = '10px';
exports.FONT_SIZE_S = '12px';
exports.FONT_SIZE_M = '14px';
exports.FONT_SIZE_DEFAULT = '14px';
exports.FONT_SIZE_L = '16px';
exports.FONT_SIZE_XL = '20px';
exports.FONT_SIZE_2XL = '24px';
exports.FONT_SIZE_3XL = '32px';
exports.FONT_SIZE_4XL = '38px';
exports.FONT_WEIGHT_DEFAULT = '400';
exports.FONT_WEIGHT_MEDIUM = '500';
exports.FONT_WEIGHT_BOLD = '700';
exports.MEDIA_XS = '18px';
exports.MEDIA_S = '24px';
exports.MEDIA_M = '34px';
exports.MEDIA_L = '50px';
exports.MEDIA_XL = '72px';
exports.SPACE_DOUBLE = '32px';
exports.SPACE_DEFAULT = '16px';
exports.SPACE_HALF = '8px';
exports.ZINDEX_NAVIGATION = '10';
exports.ZINDEX_POPOVER = '20';
exports.ZINDEX_SHIM = '30';
exports.ZINDEX_MODAL = '40';
exports.ZINDEX_CRAZY = '50';
exports.MOTION_EASING_DEFAULT = 'cubic-bezier(0.4, 0, 0.2, 1)';
exports.MOTION_EASING_DECELERATE = 'cubic-bezier(0, 0, 0.2, 1)';
exports.MOTION_EASING_ACCELERATE = 'cubic-bezier(0.4, 0, 1, 1)';